//导出所有的根 mutations 操作

export default {
  showHeader (state, status) {
    state.header = status;
  },
  showSubBar (state, status) {
    state.subBar = status;
  },
  showSFooter (state, status) {
    state.sFooter = status;
  },
  showContentFooter (state, status) {
    state.conFooter = status;
  },
  showSBg (state,status) {
    state.sBg = status;
  },
  showPopWindow(state, type) {
    state[type] = true;
  },
  hidePopWindow(state, type) {
    state[type] = false;
  },
  login (state, user){
    state.hasLogin = true;
    state.user = user;
  },
  logout (state) {
    state.hasLogin = false;
    state.user = null;
  },
  showMsgModal (state, status,msg) {
    state.msgModal.showMsgModal = status;
  },
  setModal (state,setModal) {
    state.msgModal.setModal = setModal;
  },
  showUserAgree (state,status){
    state.userAgreeState =  status;
  },
  getAccount (state) {

  },
  sideNavOpen (state, status) { 
    state.sideNavOpen = status;
  },
  showLoading(state,status){
    state.isLoading = status;
  },
  showLoadingBg(state, status){
    state.isLoadingBg = status;
  },
  updateUser(state, user){
    state.user = user;
  },
  showAboutTruthso (state, status) {
    state.aboutTruthso = status;
  },
  showLoadingPersonal (state, status) {
    state.isLoadingPersonal = status;
  },
  setCurrentHeader (state, currentPos) {
    console.log('change header:', currentPos)
    state.isIndex = false;
    state.isFeedback = false;
    state.isResults = false;
    state.isPersonal = false;
    switch (currentPos) {
      case 'index': state.isIndex = true; break;
      case 'feedback': state.isFeedback = true; break;
      case 'results': state.isResults = true; break;
      case 'personal': state.isPersonal = true; break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js